// extracted by mini-css-extract-plugin
module.exports = {"container":"AthleteCard_container__ddCIg","socialMediaCard":"AthleteCard_socialMediaCard__hRJ5e","storybookContainer":"AthleteCard_storybookContainer__Maj0c"};